import { Theme } from '../../shared/enums';

export type DsTheme = 'dark' | 'light';

export function themeAttribute(theme?: Theme): DsTheme {
  return theme === Theme.WaveLight ? 'light' : 'dark';
}
